export const FETCH_NOTIFICATION = 'FETCH_NOTIFICATION';
export const FETCH_NOTIFICATION_FULFUILED = 'FETCH_NOTIFICATION_FULFUILED';
export const MARK_AS_READ = 'MARK_AS_READ';
export const MARK_ALL_AS_READ = 'MARK_ALL_AS_READ';
